const defaultState = {
  cityId: null
};

export default defaultState;
